/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServePublicRpc
 */
import * as References from './SelfServePublicRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServePublicRpc#getAllPublishedCollections
 */
export const GET_ALL_PUBLISHED_COLLECTIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_SelfServePublicRpc_getAllPublishedCollections';
export const GET_ALL_PUBLISHED_COLLECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_PUBLISHED_COLLECTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllPublishedCollectionsRpc, {
      timeout: ctx.timeout
    });
  }
});